// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LabeledLink from '../../../../product/shared/components/labeled-link';
import LabeledString from '../../../../shared/components/labeled-string';
import {Link} from 'react-router';
import {buildClaimRoutes} from '../../../../shared/services/build-claim-route';
import {buildCurrency} from '../../../../shared/services/build-number';
import {formatClaimNumber} from '../../../../shared/services/format-claim-number';

const PercentageDebitInfoPanel = props => {

    const claimRoute = buildClaimRoutes(props.claimType.key, props.claimSubType.key, props.claimNumber);

    return (
        <div className='percentage-debit-info-panel'>
            <div className='row'>
                <Link
                    className='claim-number'
                    to={claimRoute}
                >
                    {formatClaimNumber(props.claimNumber)}
                </Link>
                {` ${props.claimType.value} ${props.claimSubType.value ? ` - ${props.claimSubType.value}` : ''}`}
            </div>
            <div className='claim-info'>
                <LabeledString
                    className='dealer-location'
                    data={props.dealerLocation}
                    label='DEALER_LOCATION'
                />
                <LabeledString
                    className='net-amount-paid'
                    data={buildCurrency(props.netAmountPaid)}
                    label='NET_AMOUNT_PAID'
                />
            </div>
            <LabeledLink
                data={props.pin}
                href={`#/products/${props.pin}`}
                label='PIN'
            />
        </div>
    );

};

PercentageDebitInfoPanel.displayName = 'PercentageDebitInfoPanel';

PercentageDebitInfoPanel.propTypes = {
    claimNumber: PropTypes.string.isRequired,
    claimSubType: PropTypes.instanceOf(KeyValuePair).isRequired,
    claimType: PropTypes.instanceOf(KeyValuePair).isRequired,
    dealerLocation: PropTypes.string.isRequired,
    netAmountPaid: PropTypes.number,
    pin: PropTypes.string.isRequired
};

export default PercentageDebitInfoPanel;



// WEBPACK FOOTER //
// ./src/tcsm/percentage-debit/components/percentage-debit-info-panel/percentage-debit-info-panel.js